/* eslint-disable */
import React, { Fragment } from 'react'
import { TitleOne, BorderText, Paragraph } from '../../../components/text'
import styled from 'styled-components'
import social from '../../../static/images/about/mission/ic-social.webp'
import economic from '../../../static/images/about/mission/ic-economic.webp'
import { useTranslation } from "react-i18next";

const OverViewValueCardStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
  @media screen and (min-width: 300px) and (max-width: 1023px) {
    border: solid 1px #ff7c00;
    border-radius: 8px;
    padding: 24px;
    display: block;
    text-align: center;
  }
  .image {
    height: 120px;
    width: 120px;

    > img {
      display: block;
      width: 100%;
    }
  }
  .title {
    color: #555555;
    font-family: 'Open Sans';
    font-size: 24px;
    font-weight: 600;
    line-height: 33px;
  }
  .desc {
    color: #888888;
    font-family: 'Open Sans';
    font-size: 18px;
    line-height: 29px;
    margin-top: 15px;
  }
  .right {
    width: 75%;
  }

  @media screen and (min-width: 300px) and (max-width: 1023px) {
    .image {
      display: inline-block;
    }

    .right {
      width: 100%;
    }
  }
`

export const AboutMissionTitleCard = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop:
          window.innerWidth >= 300 && window.innerWidth <= 1023 ? 40 : 100
      }}
    >
      <OverViewValueCardStyle>
        <div className="image">
          <img src={social} alt="" />
        </div>
        <div className="right">
          <div className="title">{t('pageAbout.part8')}</div>
          <div className="desc">
            {t('pageAbout.part9')}
          </div>
        </div>
      </OverViewValueCardStyle>
      <OverViewValueCardStyle>
        <div className="image">
          <img src={economic} alt="" />
        </div>
        <div className="right">
          <div className="title">{t('pageAbout.part10')}</div>
          <div className="desc">
            {t('pageAbout.part11')}
          </div>
        </div>
      </OverViewValueCardStyle>
    </div>
  )
}

export const AboutMissionTitle = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <TitleOne display="block" align="left">
        {t('pageAbout.part6')}
      </TitleOne>
      <div style={{ marginTop: 20 }}>
        <Paragraph style={{ display: 'block' }}>
          {t('pageAbout.part7')}
        </Paragraph>
      </div>
      <BorderText></BorderText>
    </Fragment>
  )
}
